export function modalVisible(obj: { trigger: string; }) {
  class ModalVisible {
    body: HTMLBodyElement;
    triggers: NodeListOf<Element>;
    closeButtons: NodeListOf<Element>;
    resetButtons: NodeListOf<Element>;
    scrollPos: number;

    constructor() {
      this.body = document.querySelector('body');
      this.triggers = document.querySelectorAll(`.${obj.trigger}`)
      this.closeButtons = document.querySelectorAll(`.${obj.trigger}__close`);
      this.resetButtons = document.querySelectorAll(`.${obj.trigger}__row_reset`);
      this.scrollPos = 0;
      this.init();
    }

    init() {
      Array.prototype.forEach.call(this.triggers, (trigger) => {
        this.modalVisible(trigger);
      });
    }

    modalVisible(trigger) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const modalIndex = trigger.getAttribute('data-modal');
        const modalObj = document.querySelector(`[data-modal-id="${modalIndex}"]`) as HTMLElement;
        setTimeout(() => {
          modalObj.classList.add('is-active');
          this.bodyScrollPrevent(true);
        }, 100);
        this.scrollPos = window.scrollY;
        this.closeButtons = document.querySelectorAll(`.${obj.trigger}__close`);
        Array.prototype.forEach.call(this.closeButtons, (button) => {
          this.modalClose(button);
        });
        this.resetButtons = document.querySelectorAll(`.${obj.trigger}__row_reset`);
        Array.prototype.forEach.call(this.resetButtons, (button) => {
          this.modalRowReset(button);
        });
      });
    }

    modalClose(button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const modal = button.closest('.o-modal');
        modal.classList.remove('is-active');
        setTimeout(() => {
          this.bodyScrollPrevent(false);
        }, 300);
      });
    }

    modalRowReset(button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const row = button.closest('.o-search-modal_list-item');
        const checks = row.querySelectorAll('input[type="checkbox"]');
        Array.prototype.forEach.call(checks, (check) => {
          check.checked = false;
        });
      });
    }

    bodyScrollPrevent(flag) {
      const ua = window.navigator.userAgent.toLowerCase();
      const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;

      if(flag){
        if(isiOS){
          this.scrollPos
          this.body.style.position = 'fixed';
          this.body.style.width = '100%';
          this.body.style.top = - this.scrollPos + 'px';
        } else {
          this.body.style.overflow = 'hidden';
        }
      } else if(!flag) {
        if(isiOS){
          this.scrollPos = parseInt(this.body.style.top.replace(/[^0-9]/g,''));
          this.body.style.position = '';
          this.body.style.width = '';
          this.body.style.top = '';
          window.scrollTo(0, this.scrollPos);
        }else {
          this.body.style.overflow = '';
        }
      }
    }

  }

  new ModalVisible();
}

